webpackJsonp([2,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(3);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueResource = __webpack_require__(92);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _elementUi = __webpack_require__(59);
	
	var _elementUi2 = _interopRequireDefault(_elementUi);
	
	__webpack_require__(73);
	
	var _App = __webpack_require__(80);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _vueRouter = __webpack_require__(93);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _Home = __webpack_require__(84);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	var _Doc = __webpack_require__(82);
	
	var _Doc2 = _interopRequireDefault(_Doc);
	
	var _API = __webpack_require__(81);
	
	var _API2 = _interopRequireDefault(_API);
	
	var _Download = __webpack_require__(83);
	
	var _Download2 = _interopRequireDefault(_Download);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_elementUi2.default);
	_vue2.default.use(_vueResource2.default);
	_vue2.default.use(_vueRouter2.default);
	
	var router = new _vueRouter2.default({
	  routes: [{ path: '/', component: _Home2.default }, { path: '/home', component: _Home2.default }, { path: '/doc', component: _Doc2.default }, { path: '/doc/:theme', component: _Doc2.default }, { path: '/doc/:theme/:item', component: _Doc2.default }, { path: '/api', component: _API2.default }, { path: '/api/:theme', component: _API2.default }, { path: '/api/:theme/:item', component: _API2.default }, { path: '/download', component: _Download2.default }]
	
	});
	
	var bus = new _vue2.default();
	
	new _vue2.default({
	  el: '#app',
	  template: '<App/>',
	  render: function render(h) {
	    return h(_App2.default);
	  },
	  components: { App: _App2.default },
	  router: router
	});

/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.bus = undefined;
	
	var _vue = __webpack_require__(3);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var bus = exports.bus = new _vue2.default();

/***/ },
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var docCache = exports.docCache = [];
	
	var apiCache = exports.apiCache = [];

/***/ },
/* 18 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.elementPosition = elementPosition;
	exports.ScrollToControl = ScrollToControl;
	function elementPosition(obj) {
	  var curleft = 0;
	  var curtop = 0;
	  if (obj.offsetParent) {
	    curleft = obj.offsetLeft;
	    curtop = obj.offsetTop;
	    obj = obj.offsetParent;
	    while (obj) {
	      curleft += obj.offsetLeft;
	      curtop += obj.offsetTop;
	      obj = obj.offsetParent;
	    }
	  }
	  return { x: curleft, y: curtop };
	}
	
	function ScrollToControl(id) {
	  var h = window.scrollY;
	  console.log('id: ' + id);
	  if (id === '') {
	    window.scrollBy(0, 0 - h - 60);
	  } else {
	    var elem = document.getElementById(id);
	    if (elem) {
	      var scrollPos = elementPosition(elem).y;
	      scrollPos = scrollPos - h - 60;
	      console.log('document: ' + h + ', ele: ' + elementPosition(elem).y);
	      window.scrollBy(0, scrollPos);
	    }
	  }
	}

/***/ },
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TopNav = __webpack_require__(85);
	
	var _TopNav2 = _interopRequireDefault(_TopNav);
	
	var _bus = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  components: {
	    'top-nav': _TopNav2.default
	  }
	};

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _bus = __webpack_require__(7);
	
	var _scroll = __webpack_require__(18);
	
	var _data = __webpack_require__(17);
	
	var _marked = __webpack_require__(24);
	
	var _marked2 = _interopRequireDefault(_marked);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      api_nav: '',
	      content: '',
	      padding_bottom: 0
	    };
	  },
	
	
	  methods: {
	    scroll: function scroll(item) {
	      var _this = this;
	
	      if (this.imgLoaded()) {
	        (0, _scroll.ScrollToControl)(item);
	      } else {
	        window.setTimeout(function () {
	          _this.scroll(item);
	        }, 50);
	      }
	    },
	    fetch_api_nav: function fetch_api_nav() {
	      var _this2 = this;
	
	      var url = 'static/apis/nav.json';
	      this.$http.get(url).then(function (response) {
	        _this2.api_nav = response.body;
	      }, function (response) {});
	    },
	    set_content: function set_content(content, f) {
	      this.content = content;
	      this.$nextTick(f);
	    },
	    fetch_api_content: function fetch_api_content() {
	      var _this3 = this;
	
	      var theme = this.routeTheme();
	      var item = this.routeItem();
	
	      console.log(_data.apiCache);
	      console.log(theme + ' ' + item);
	      if (_data.apiCache.theme && theme === _data.apiCache.theme) {
	        console.log(1);
	        this.scroll(item);
	      } else if (theme in _data.apiCache) {
	        console.log(2);
	        this.set_content(_data.apiCache[theme], function () {
	          _this3.scroll(item);
	          _data.apiCache.theme = theme;
	        });
	      } else {
	        console.log(3);
	        var url = 'static/apis/' + theme + '.md';
	        this.$http.get(url).then(function (response) {
	          _this3.set_content((0, _marked2.default)(response.body), function () {
	            console.log(item);
	            _this3.scroll(item);
	            _data.apiCache[theme] = _this3.content;
	            _data.apiCache.theme = theme;
	          });
	        }, function (response) {});
	      }
	    },
	    imgLoaded: function imgLoaded() {
	      var ls = document.querySelectorAll('.api-content img');
	      var len = ls.length;
	      for (var i = 0; i < len; i++) {
	        var e = ls[i];
	        if (!e.complete) return false;
	      }
	      return true;
	    },
	    aboveTopVisualArea: function aboveTopVisualArea(e) {
	      try {
	        var hw = window.scrollY;
	        var r = e.href.match(/#\/api\/.+\/(.+)$/);
	        var item = r[1];
	        var el = document.getElementById(item);
	        var p = (0, _scroll.elementPosition)(el).y;
	        return p <= hw + 60;
	      } catch (e) {
	        return false;
	      }
	    },
	    routeItem: function routeItem() {
	      var params = this.$route.params;
	      var item = params.item ? params.item : '';
	      return item;
	    },
	    routeTheme: function routeTheme() {
	      var params = this.$route.params;
	      var theme = params.theme ? params.theme : 'index';
	      return theme;
	    },
	    pathTheme: function pathTheme(path) {
	      try {
	        var r = path.match(/#\/api\/(.+)\/(.+)$/);
	        return r[1];
	      } catch (e) {
	        return '';
	      }
	    },
	    handleScroll: function handleScroll() {
	      var ls = document.querySelectorAll('.api-item a');
	      var len = ls.length;
	      var theme = this.routeTheme();
	      for (var i = 0; i < len; i++) {
	        var e1 = ls[i];
	        var e2 = ls[i + 1];
	        if (this.pathTheme(e1.href) === theme && this.aboveTopVisualArea(e1) && !this.aboveTopVisualArea(e2)) {
	          e1.setAttribute('class', 'active');
	        } else {
	          e1.setAttribute('class', '');
	        }
	      }
	    },
	    handleResized: function handleResized() {
	      var h = window.innerHeight;
	      this.padding_bottom = h - 150;
	    }
	  },
	
	  created: function created() {
	    this.fetch_api_nav();
	    this.fetch_api_content();
	    this.handleResized();
	    window.addEventListener('scroll', this.handleScroll);
	    window.addEventListener('resize', this.handleResized);
	  },
	
	
	  watch: {
	    '$route': function $route(to, from) {
	      this.fetch_api_content();
	    }
	  },
	
	  destroyed: function destroyed() {
	    _data.apiCache.theme = '';
	  }
	};

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _bus = __webpack_require__(7);
	
	var _scroll = __webpack_require__(18);
	
	var _data = __webpack_require__(17);
	
	var _marked = __webpack_require__(24);
	
	var _marked2 = _interopRequireDefault(_marked);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      doc_nav: '',
	      content: '',
	      padding_bottom: 0
	    };
	  },
	
	
	  methods: {
	    scroll: function scroll(item) {
	      var _this = this;
	
	      if (this.imgLoaded()) {
	        (0, _scroll.ScrollToControl)(item);
	      } else {
	        window.setTimeout(function () {
	          _this.scroll(item);
	        }, 50);
	      }
	    },
	    fetch_doc_nav: function fetch_doc_nav() {
	      var _this2 = this;
	
	      var url = 'static/docs/nav.json';
	      this.$http.get(url).then(function (response) {
	        _this2.doc_nav = response.body;
	      }, function (response) {});
	    },
	    set_content: function set_content(content, f) {
	      this.content = content;
	      this.$nextTick(f);
	    },
	    fetch_doc_content: function fetch_doc_content() {
	      var _this3 = this;
	
	      var params = this.$route.params;
	      var theme = params.theme ? params.theme : 'install';
	      var item = params.item ? params.item : '';
	      console.log(_data.docCache);
	      console.log(theme + ' ' + item);
	      if (_data.docCache.theme && theme === _data.docCache.theme) {
	        console.log(1);
	        this.scroll(item);
	      } else if (theme in _data.docCache) {
	        console.log(2);
	        this.set_content(_data.docCache[theme], function () {
	          _this3.scroll(item);
	          _data.docCache.theme = theme;
	        });
	      } else {
	        console.log(3);
	        var url = 'static/docs/' + theme + '.md';
	        this.$http.get(url).then(function (response) {
	          _this3.set_content((0, _marked2.default)(response.body), function () {
	            console.log(item);
	            _this3.scroll(item);
	            _data.docCache[theme] = _this3.content;
	            _data.docCache.theme = theme;
	          });
	        }, function (response) {});
	      }
	    },
	    imgLoaded: function imgLoaded() {
	      var ls = document.querySelectorAll('.doc-content img');
	      var len = ls.length;
	      for (var i = 0; i < len; i++) {
	        var e = ls[i];
	        if (!e.complete) return false;
	      }
	      return true;
	    },
	    aboveTopVisualArea: function aboveTopVisualArea(e) {
	      try {
	        var hw = window.scrollY;
	        var r = e.href.match(/#\/doc\/.+\/(.+)$/);
	        var item = r[1];
	        var el = document.getElementById(item);
	        var p = (0, _scroll.elementPosition)(el).y;
	        return p <= hw + 60;
	      } catch (e) {
	        return false;
	      }
	    },
	    routeTheme: function routeTheme() {
	      var params = this.$route.params;
	      var theme = params.theme ? params.theme : 'install';
	      return theme;
	    },
	    pathTheme: function pathTheme(path) {
	      try {
	        var r = path.match(/#\/doc\/(.+)\/(.+)$/);
	        return r[1];
	      } catch (e) {
	        return '';
	      }
	    },
	    handleScroll: function handleScroll() {
	      var ls = document.querySelectorAll('.doc-item a');
	      var len = ls.length;
	      var theme = this.routeTheme();
	      for (var i = 0; i < len; i++) {
	        var e1 = ls[i];
	        var e2 = ls[i + 1];
	        if (this.pathTheme(e1.href) === theme && this.aboveTopVisualArea(e1) && !this.aboveTopVisualArea(e2)) {
	          e1.setAttribute('class', 'active');
	        } else {
	          e1.setAttribute('class', '');
	        }
	      }
	    },
	    handleResized: function handleResized() {
	      var h = window.innerHeight;
	      this.padding_bottom = h - 150;
	    }
	  },
	
	  created: function created() {
	    this.fetch_doc_nav();
	    this.fetch_doc_content();
	    this.handleResized();
	    window.addEventListener('scroll', this.handleScroll);
	    window.addEventListener('resize', this.handleResized);
	  },
	
	
	  watch: {
	    '$route': function $route(to, from) {
	      this.fetch_doc_content();
	    }
	  },
	
	  destroyed: function destroyed() {
	    _data.docCache.theme = '';
	  }
	};

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _bus = __webpack_require__(7);
	
	exports.default = {};

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _bus = __webpack_require__(7);
	
	exports.default = {};

/***/ },
/* 53 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'nav',
	
	  data: function data() {
	    return {
	      top: []
	    };
	  },
	  created: function created() {
	    this.fetch_data();
	  },
	
	
	  methods: {
	    fetch_data: function fetch_data() {
	      var v = this;
	      this.$http.get('static/top.json').then(function (response) {
	        v.top = response.body;
	      }, function (response) {});
	    },
	    handleSelect: function handleSelect(key, keyPath) {}
	  }
	};

/***/ },
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 74 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 75 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 76 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 77 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 78 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 79 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(78)
	
	var Component = __webpack_require__(6)(
	  /* script */
	  __webpack_require__(48),
	  /* template */
	  __webpack_require__(90),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(77)
	
	var Component = __webpack_require__(6)(
	  /* script */
	  __webpack_require__(49),
	  /* template */
	  __webpack_require__(89),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(74)
	
	var Component = __webpack_require__(6)(
	  /* script */
	  __webpack_require__(50),
	  /* template */
	  __webpack_require__(86),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(79)
	
	var Component = __webpack_require__(6)(
	  /* script */
	  __webpack_require__(51),
	  /* template */
	  __webpack_require__(91),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(76)
	
	var Component = __webpack_require__(6)(
	  /* script */
	  __webpack_require__(52),
	  /* template */
	  __webpack_require__(88),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(75)
	
	var Component = __webpack_require__(6)(
	  /* script */
	  __webpack_require__(53),
	  /* template */
	  __webpack_require__(87),
	  /* scopeId */
	  "data-v-17b44d5a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 86 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('el-row', {
	    staticClass: "doc"
	  }, [_c('el-col', {
	    staticClass: "sidebar",
	    attrs: {
	      "span": 6
	    }
	  }, [_c('div', {
	    staticClass: "doc-nav"
	  }, [_c('h2', [_c('a', {
	    attrs: {
	      "href": "#/doc"
	    }
	  }, [_vm._v("Documentation")])]), _vm._v(" "), _c('p', [_c('a', {
	    attrs: {
	      "href": "https://github.com/hust220/nsp"
	    }
	  }, [_vm._v("Github")])]), _vm._v(" "), _c('ul', _vm._l((_vm.doc_nav), function(theme) {
	    return _c('li', {
	      staticClass: "doc-theme"
	    }, [_c('strong', [_c('a', {
	      class: [theme.href == '#' + _vm.$route.path ? 'active' : ''],
	      attrs: {
	        "href": theme.href
	      },
	      domProps: {
	        "textContent": _vm._s(theme.text)
	      }
	    })]), _vm._v(" "), _c('ul', _vm._l((theme.items), function(item) {
	      return _c('li', {
	        staticClass: "doc-item"
	      }, [_c('a', {
	        class: [item.href == '#' + _vm.$route.path ? 'active' : ''],
	        attrs: {
	          "href": item.href
	        },
	        domProps: {
	          "textContent": _vm._s(item.text)
	        }
	      })])
	    }))])
	  }))])]), _vm._v(" "), _c('el-col', {
	    staticClass: "main",
	    attrs: {
	      "span": 18,
	      "offset": 6
	    }
	  }, [_c('div', {
	    staticClass: "doc-content",
	    style: ('padding-bottom: ' + _vm.padding_bottom + 'px'),
	    domProps: {
	      "innerHTML": _vm._s(_vm.content)
	    }
	  })])], 1)
	},staticRenderFns: []}

/***/ },
/* 87 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('el-row', {
	    staticClass: "top-nav"
	  }, [_c('el-menu', {
	    staticClass: "el-menu-demo",
	    attrs: {
	      "default-active": "1",
	      "mode": "horizontal"
	    },
	    on: {
	      "select": _vm.handleSelect
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 22,
	      "offset": 1
	    }
	  }, [('logo' in _vm.top) ? _c('router-link', {
	    attrs: {
	      "to": "/home"
	    }
	  }, [_c('el-menu-item', {
	    attrs: {
	      "index": "1"
	    }
	  }, [_c('img', {
	    staticClass: "nsp-logo",
	    attrs: {
	      "src": 'static/' + _vm.top.logo
	    }
	  })])], 1) : _vm._e(), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "to": "/doc"
	    }
	  }, [_c('el-menu-item', {
	    attrs: {
	      "index": "1"
	    }
	  }, [_vm._v("Documentation")])], 1), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "to": "/api"
	    }
	  }, [_c('el-menu-item', {
	    attrs: {
	      "index": "1"
	    }
	  }, [_vm._v("API")])], 1), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "to": "/download"
	    }
	  }, [_c('el-menu-item', {
	    attrs: {
	      "index": "1"
	    }
	  }, [_vm._v("Download")])], 1), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "mailto:wj_hust08@hust.edu.cn?cc=yxiao@hust.edu.cn"
	    }
	  }, [_c('el-menu-item', {
	    attrs: {
	      "index": "1"
	    }
	  }, [_vm._v("Contact\n        ")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "line"
	  })], 1)
	},staticRenderFns: []}

/***/ },
/* 88 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "home"
	  }, [_c('table', [_c('tr', [_c('td', {
	    attrs: {
	      "rowspan": "2"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "static/logo.png"
	    }
	  })]), _vm._v(" "), _c('td', {
	    staticClass: "home-nsp-intro",
	    attrs: {
	      "colspan": "2"
	    }
	  }, [_vm._v("Nucleic acids"), _c('br'), _vm._v("Structure Prediction")])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
	    attrs: {
	      "href": "#/doc"
	    }
	  }, [_vm._v("Documentation")])]), _vm._v(" "), _c('td', [_c('a', {
	    attrs: {
	      "href": "https://github.com/hust220/nsp"
	    }
	  }, [_vm._v("Github")])])])])])
	}]}

/***/ },
/* 89 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('el-row', {
	    staticClass: "api"
	  }, [_c('el-col', {
	    staticClass: "sidebar",
	    attrs: {
	      "span": 6
	    }
	  }, [_c('div', {
	    staticClass: "api-nav"
	  }, [_c('h2', [_c('a', {
	    attrs: {
	      "href": "#/api"
	    }
	  }, [_vm._v("API")])]), _vm._v(" "), _c('p', [_c('a', {
	    attrs: {
	      "href": "https://github.com/hust220/nsp"
	    }
	  }, [_vm._v("Github")])]), _vm._v(" "), _c('ul', _vm._l((_vm.api_nav), function(theme) {
	    return _c('li', {
	      staticClass: "api-theme"
	    }, [_c('strong', [_c('a', {
	      class: [theme.href == '#' + _vm.$route.path ? 'active' : ''],
	      attrs: {
	        "href": theme.href
	      },
	      domProps: {
	        "textContent": _vm._s(theme.text)
	      }
	    })]), _vm._v(" "), _c('ul', _vm._l((theme.items), function(item) {
	      return _c('li', {
	        staticClass: "api-item"
	      }, [_c('a', {
	        class: [item.href == '#' + _vm.$route.path ? 'active' : ''],
	        attrs: {
	          "href": item.href
	        },
	        domProps: {
	          "textContent": _vm._s(item.text)
	        }
	      })])
	    }))])
	  }))])]), _vm._v(" "), _c('el-col', {
	    staticClass: "main",
	    attrs: {
	      "span": 18,
	      "offset": 6
	    }
	  }, [_c('div', {
	    staticClass: "api-content",
	    style: ('padding-bottom: ' + _vm.padding_bottom + 'px'),
	    domProps: {
	      "innerHTML": _vm._s(_vm.content)
	    }
	  })])], 1)
	},staticRenderFns: []}

/***/ },
/* 90 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('top-nav', {
	    staticClass: "layout-nav"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "layout-page"
	  }, [_c('router-view')], 1)], 1)
	},staticRenderFns: []}

/***/ },
/* 91 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('el-row', [_c('el-col', {
	    attrs: {
	      "span": 16,
	      "offset": 4
	    }
	  }, [_c('el-card', {
	    staticClass: "download"
	  }, [_c('ul', [_c('li', [_c('a', {
	    attrs: {
	      "href": "http://biophy.hust.edu.cn/download/nsp.tar.gz"
	    }
	  }, [_vm._v("Source code")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "http://biophy.hust.edu.cn/download/nsp-lib.tar.gz"
	    }
	  }, [_vm._v("Templates library")])])])])], 1)], 1)
	},staticRenderFns: []}

/***/ },
/* 92 */,
/* 93 */,
/* 94 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ }
]);


// WEBPACK FOOTER //
// static/js/app.81e41d57ca6db197289f.js